<div class="composed-controls">
    <app-button 
    styleClass="settings"
    subStyle="blue"
    customClasses="attach-btn pl-4 !pr-10"
    [placement]="positionMenuContent()"
    [text]="'Reconcile'"
    appMenu
    [autoClose]="'outside'"
    [menuContent]="transactionsMenuContent"
    triggers="manual"
    #transactionsMenu="appMenu"
    (click)="transactionsMenu.toggle();$event.stopPropagation();"
    >
      <img [class.opened]="transactionsMenu.isOpen()" class="select-transaction-btn-icon" src="assets/icons/icon-chevron-down-blue.svg" alt="chevron-down" />
    </app-button>
</div>

<ng-template #transactionsMenuContent>
    <div class="menu-container primary">
     
      <div *ngIf="!displayDeductInventoryActions"
      (click)="openTransactionDialog('showReceiveDialog', $event)" 
           class="menu-item"
      >
        <div class="option">Receive Inventory</div>
      </div>
      <ng-container *ngIf="displayDeductInventoryActions">
        <div (click)="openTransactionDialog('showDispenseDialog', $event)" class="menu-item">
          <div class="option">Dispense</div>
        </div>
        <div (click)="openTransactionDialog('showRecordLostDialog', $event)" class="menu-item">
          <div class="option">Report Lost or Stolen</div>
        </div>
        <div *ngIf="displayDamagedExpired"
          (click)="openTransactionDialog('showDamagedOrExpiredDialog', $event)" class="menu-item">
          <div class="option">Meds Damaged or Expired</div>
        </div>
        <!-- <div (click)="openTransactionDialog('showMoveInventoryDialog', $event)" class="menu-item">
          <div class="option">Move Inventory</div>
        </div> -->
      </ng-container>
      <div (click)="noteOtherReasonOptionSelected.next()" class="menu-item">
        <div class="option">Notes/Other Reason</div>
      </div>
    </div>
  </ng-template>

<app-multiple-drugs-dialog-base *ngIf="showDispenseDialog"
  header="Dispensing"
  [dialogType]="DialogTypeEnum.DispenseInAuditAdjustment" 
  (cancel)="showDispenseDialog = false"
  (save)="dispenseDrug($event)"
  [selectedDrug]="composeDrug()"
  [excludedLocations]="getLocationIDsToExclude()"
  submitBtnText="Dispense"
  [maxValueExceededErrorMessage]="maxValueExceededErrorMessage"
></app-multiple-drugs-dialog-base>

<app-receive-dialog *ngIf="showReceiveDialog"
  (cancel)="showReceiveDialog = false"
  (save)="receiveDrug($event)"
  [selectedDrug]="composeDrug()"
  [excludedLocations]="getLocationIDsToExclude()"
  [dialogType]="DialogTypeEnum.ReceiveInAuditAdjustment"
  [maxValueExceededErrorMessage]="maxValueExceededErrorMessage" 
></app-receive-dialog>

<app-multiple-drugs-dialog-base *ngIf="showRecordLostDialog"
  header="Recording Lost or Stolen"
  [dialogType]="DialogTypeEnum.OtherActionsInAuditAdjustment" 
  (cancel)="showRecordLostDialog = false"
  (save)="recordLostOrStolenDrug($event)"
  [selectedDrug]="composeDrug()"
  [excludedLocations]="getLocationIDsToExclude()"
  submitBtnText="Record Lost/Stolen"
  [maxValueExceededErrorMessage]="maxValueExceededErrorMessage"
></app-multiple-drugs-dialog-base>

<app-multiple-drugs-dialog-base *ngIf="showDamagedOrExpiredDialog"
  header="Recording Damaged or Expired"
  [hideHeaderUnderline]="true"
  [dialogType]="DialogTypeEnum.OtherActionsInAuditAdjustment" 
  (cancel)="showDamagedOrExpiredDialog = false"
  (save)="recordDamagedOrExpiredDrug($event)"
  [selectedDrug]="composeDrug()"
  [excludedLocations]="getLocationIDsToExclude()"
  submitBtnText="Record Damaged/Expired"
  [maxValueExceededErrorMessage]="maxValueExceededErrorMessage"
>
<div class="sub-header-container flex flex-col" subHeader *ngIf="inventoryLocationsEnabled$ | async">
  <div class="flex">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none" class="mt-1">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08264 1.40854C7.92371 -0.0866987 10.0765 -0.0866995 10.9176 1.40853L17.0559 12.3211C17.8808 13.7877 16.8211 15.5997 15.1384 15.5997H2.86177C1.17915 15.5997 0.119383 13.7877 0.944306 12.3211L7.08264 1.40854ZM10.1 12.2998C10.1 12.9073 9.60753 13.3998 9.00001 13.3998C8.3925 13.3998 7.90001 12.9073 7.90001 12.2998C7.90001 11.6923 8.3925 11.1998 9.00001 11.1998C9.60753 11.1998 10.1 11.6923 10.1 12.2998ZM9.00001 3.49983C8.3925 3.49983 7.90001 3.99232 7.90001 4.59983V7.89983C7.90001 8.50734 8.3925 8.99983 9.00001 8.99983C9.60752 8.99983 10.1 8.50734 10.1 7.89983V4.59983C10.1 3.99232 9.60752 3.49983 9.00001 3.49983Z" fill="#F87171"/>
    </svg> 
    <div class="sub-header">The drug & quantity will be automatically transferred to the Damage/Expired inventory location.</div>
  </div>
 
  <div class="mb-2"></div>
</div>
</app-multiple-drugs-dialog-base>

<app-move-inventory-dialog *ngIf="showMoveInventoryDialog"
  [selectedDrug]="getSelectedDrugToMove()"
  (cancel)="showMoveInventoryDialog = false"
></app-move-inventory-dialog>